export class AssertionError extends Error {}

export function assert(exp: boolean, message: string) {
  if (!exp) {
    throw new AssertionError(message)
  }
}
